/**
 * @file The Alerts service
 * @author Heino Lenting
 */
/**
 * Class for the alerts service
 */
var AlertsService = /** @class */ (function () {
    function AlertsService() {
        this.alerts = [];
        this.lastId = 0;
    }
    /**
     * Create an alert and add to alerts queue
     * @param variant The alert variant (succes, info, warning, or danger)
     * @param labelKey The label key of the message
     * @param details Optional details or Error can be given
     */
    AlertsService.prototype.createAlert = function (variant, labelKey, details) {
        var _this = this;
        // Increase lastId
        this.lastId += 1;
        // Store new id
        var id = this.lastId;
        // If variant is warning or danger we want details! ;-)
        if (!details && (variant === 'warning' || variant === 'danger')) {
            console.warn('Alert of variant ' + variant + ' created without details (often an Error) is an anti-pattern');
        }
        // Create alert (+ timer for deleting after a few seconds)
        var alert = {
            'id': id,
            'variant': variant,
            'labelKey': labelKey,
            'details': details,
            'open': false,
            'timer': window.setTimeout(function () { _this.deleteAlert(id); }, 10000)
        };
        // Add to alerts
        this.alerts.unshift(alert);
    };
    /**
     * Stop de auto delete of a alert
     * @param id The id of the alert
     */
    AlertsService.prototype.stopAutoDelete = function (id) {
        var index = this.findIndex(id);
        if (index !== undefined) {
            // Clear existing timer
            clearTimeout(this.alerts[index].timer);
        }
    };
    /**
     * Start de auto delete of a alert
     * @param id The id of the alert
     * @param millisecons The time to wait before deleting the alert
     */
    AlertsService.prototype.startAutoDelete = function (id, milliseconds) {
        var self = this;
        var index = this.findIndex(id);
        if (index !== undefined) {
            // Create new timer
            this.alerts[index].timer = window.setTimeout(function () { self.deleteAlert(id); }, milliseconds);
        }
    };
    /**
     * Postpone the auto delete (used if user hovers the alert)
     * @param id The id of the alert
     */
    AlertsService.prototype.postponeDeleting = function (id) {
        this.stopAutoDelete(id);
        this.startAutoDelete(id, 60000);
    };
    /**
     * Delete the alert from the alerts queue
     * @param id The id of the alert
     */
    AlertsService.prototype.deleteAlert = function (id) {
        var index = this.findIndex(id);
        // Explicitly delete the timer
        this.stopAutoDelete(id);
        // Remove alert from alerts
        if (index !== undefined && this.alerts.length >= index) {
            this.alerts.splice(index, 1);
        }
    };
    /**
     * Get the alert for the alerts queue
     * @param id The id of the alert
     */
    AlertsService.prototype.getAlert = function (id) {
        var index = this.findIndex(id);
        if (index !== undefined) {
            return this.alerts[index];
        }
        return undefined;
    };
    /**
     * Translate an alert id to the position (index) in the queue
     * @param id The id of the alert
     * @returns The position in the queue
     */
    AlertsService.prototype.findIndex = function (id) {
        var index;
        // Find the alert based on id
        this.alerts.forEach(function (alert, i) {
            if (alert.id === id) {
                index = i;
            }
        });
        return index;
    };
    return AlertsService;
}());
export { AlertsService };
